import axios from "./AxiosService";

export default class PreferencesService {
  loadPreferencekeysService() {
    return axios
      .get("CustomisedSupport")
      .then(response => {
        return response.data;
      })
      .catch(error => {
        return error.response;
      });
  }

  loadOptionValueService(membershipNumber) {
    return axios
    .get("CustomisedSupport",
    {
        params: { membershipNumber: membershipNumber }
    },
    )
    .then(response => {
      return response.data.CustomerDutyData;
    })
    .catch(error => {
      return error.response;
    });
}
saveContactPreferenceService(contactPreference){
    return axios
    .post("Contact",contactPreference)
    .then((response) => {
      return response.data;
    })
    .catch(error => {
      return error.response;
    });
  }

  saveCommunicationPreferenceService(CommunicationPreferences){
    return axios
    .post("CustomisedSupport",CommunicationPreferences)
    .then((response) => {
      return response.data;
    })
    .catch(error => {
      return error.response;
    });
  }


}